import React from 'react';
import { useSearchParams } from 'react-router-dom';
import CustomTabPanel from 'components/Shared/CustomTabPanel';
import CustomTabs from 'components/Shared/CustomTabs';
import RowsSkeleton from 'components/Shared/Skeleton/RowsSkeleton';
import NoteTab from '../../Note/Notetab';
import { useGetNotesBySourceQuery } from 'store/services/noteApi';
import { useDeliveryDetailContext } from "contexts/DeliveryDetailContext";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../Document/DocumentTab";
import DeliveryShipmentLIst from "./DeliveryShipmentLIst";
import { DeliveryPaymentDetailTab } from "./DeliveryPaymentDetailTab";

const DeliveryDetailTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'note';
  const { deliveryDetail } = useDeliveryDetailContext();

  const { data: notes } = useGetNotesBySourceQuery(
    {
      source: 'Delivery',
      sourceRef: deliveryDetail?._id,
    },
    { skip: !deliveryDetail?._id }
  );

  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: 'Delivery', sourceRef: deliveryDetail?._id },
    { skip: !deliveryDetail?._id }
  );

  const hasPaymentDetails = deliveryDetail?.paymentDetails &&
    typeof deliveryDetail.paymentDetails === 'object' &&
    Object.keys(deliveryDetail.paymentDetails).length > 0;

  const tabs = [
    {
      label: 'Note',
      value: 'note',
      badgeCount: notes?.length || 0,
    },
    {
      label: "Document",
      value: "document",
      badgeCount: documents?.totalItems,
    },
    {
      label: "Shipment",
      value: "shipment",
      badgeCount: deliveryDetail?.shipmentId?.length,
    },
    ...(hasPaymentDetails
      ? [{
        label: "Payment",
        value: "payment",
      }]
      : []
    ),
  ];

  React.useEffect(() => {
    if (!hasPaymentDetails && activeTab === 'payment') {
      searchParams.set('tab', 'note');
      setSearchParams(searchParams);
    }
  }, [hasPaymentDetails, activeTab, searchParams, setSearchParams]);

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />
      {deliveryDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="note">
            <NoteTab source="Delivery" sourceRef={deliveryDetail._id} />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab source="Delivery" sourceRef={deliveryDetail._id} />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value="shipment">
            <DeliveryShipmentLIst />
          </CustomTabPanel>
          {hasPaymentDetails && (
            <CustomTabPanel activeTab={activeTab} value="payment">
              <DeliveryPaymentDetailTab />
            </CustomTabPanel>
          )}
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default DeliveryDetailTab;